// extracted by mini-css-extract-plugin
export default {"platfromText":"GadgetCountLabel_platfromText__EgWxI"};